<template>
  <v-overlay :model-value="loading" class="align-center justify-center">
    <v-progress-circular
      indeterminate
      color="primary"
      size="64"
    ></v-progress-circular>
  </v-overlay>
</template>

<script setup>
import { useLoadingOverlay } from '@/store/loadingOverlay';
import { toRefs } from 'vue';

const loadingOverlay = useLoadingOverlay();
const { loading } = toRefs(loadingOverlay);
</script>